<template>
  <div class="solution" :class="{'solution-xs':isMobile,'english':lang=='EN'}">
    <Header ref="header" id="header"></Header>
    <div class="banner" ref="banner">
      <img v-if="curNavMenu.id == 'park'" class="img-fluid" src="../assets/img/solutions/park/banner.jpg"/>
      <img v-if="curNavMenu.id == 'education'" class="img-fluid" src="../assets/img/solutions/union/all.jpg"/>
      <img v-if="curNavMenu.id == 'airPort'" class="img-fluid" src="../assets/img/solutions/airport/banner.jpg"/>
      <img v-if="curNavMenu.id == 'traffic'" class="img-fluid" src="../assets/img/solutions/traffic/banner.jpg"/>
      <img v-if="curNavMenu.id == 'port'" class="img-fluid" src="../assets/img/solutions/ship/haiyunbanner.png"/>

    </div>
    <div class="nav-menu2 active"
         :class="{navMenu2Fixed:isNavMenu2Fixed,'nav-menu2-xs':isMobile,'active':activeChildren.id=='measurement'||activeChildren.id=='limitHigh'||activeChildren.id=='steel'}"
         ref="navMenu2">
      <div class="content">
        <div class="left-title">
          <div class="dropdown">
            <div data-toggle="dropdown" class="dropdown-ul">
              {{$t(curNavMenu.label)}}
            </div>
          </div>
        </div>
        <div class="right-tab-ul">
          <div class="hidden-xs">
            <span v-for="item in curChildrens"
                  :class="{actived:activeChildren.id == item.id}"
                  @click="changeActiveChildren(item)"
            >{{$t(item.label)}}</span>
          </div>
          <div class="visible-xs">
            <div class="dropdown" v-if="curChildrens.length > 1">
              <div data-toggle="dropdown" class="dropdown-ul" style="color:#3292FF;" id="dropdownMenu2">
                <span>{{$t(activeChildren.label)}}</span><i class="el-icon-arrow-down el-icon--right"></i>
              </div>
              <div class="dropdown-menu dropdown-menu-right">
                <p class="dropdown-item"
                   @click="changeActiveChildren(item)"
                   :class="{actived:activeChildren.id == item.id}"
                   v-for="item in curChildrens">{{$t(item.label)}}</p>
              </div>
            </div>
            <div class="div" v-else>
                <span v-for="item in curChildrens"
                      :class="{actived:activeChildren.id == item.id}"
                      @click="changeActiveChildren(item)"
                >{{$t(item.label)}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <router-view :id="activeChildren.id"></router-view>
    <Footer></Footer>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex'
  import Header from "./common/Header"
  import Footer from "./common/Footer"

  export default {
    name: "Solution",
    components: {
      Header,
      Footer
    },
    props: {},
    data() {
      return {
        isNavMenu2Fixed: false,
        curChildrens: [],
        activeChildren: '',
        curNavMenu: {},
      }
    },
    created() {
      $('html,body').scrollTop(0)
      this.initMenuInfo()
    },
    methods: {
      initMenuInfo() {
        let curNavMenuId = this.$route.name || ''
        let navMenu = this.getCurNavMenuInfo(curNavMenuId)
        if (navMenu) {
          this.curNavMenu = navMenu
          this.curChildrens = navMenu.children || []
          if (this.$route.query.child) {
            this.activeChildren = this.getChildrenById(this.$route.query.child, navMenu) || {}
          } else {
            this.activeChildren = navMenu.children && navMenu.children[0] || {}
          }
        }
      },
      getCurNavMenuInfo(id) {
        let navMenu = null
        this.solutions.forEach((el) => {
          if (el.id == id) {
            navMenu = el
          }
        })
        return navMenu
      },
      getChildrenById(id, navMenu) {
        let child = null
        let childs = navMenu.children || []
        childs.forEach((el => {
          if (el.id == id) {
            child = el
          }
        }))
        return child
      },
      changeNavMenu(item) {
        if (item.id == 'port' || item.id == 'medical') {
          return
        }
        this.curNavMenu = item
        this.curChildrens = item.children || []
        this.activeChildren = item.children && item.children[0] || {}
        this.goRouter()
        this.setScrollTop()
      },
      changeActiveChildren(item) {
        this.activeChildren = item
        this.goRouter()
        this.setScrollTop()
      },
      setScrollTop() {
        $('html,body').animate({
          scrollTop: this.$refs.banner.offsetHeight + 1
        }, 300)
      },
      goRouter() {
        let query = JSON.parse(JSON.stringify(this.$route.query))
        this.$router.push({
          name: this.curNavMenu.id,
          query: Object.assign(query, {child: this.activeChildren.id})
        })
        //顶部导航显示对应标签
        this.$store.commit('setTabInfo', {
          one: 'Solution',
          two: this.curNavMenu.id
        })
      },
      scrollEvent() {
        let screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (scrollTop > 0) {
          this.$refs.header.setHeaderFixed(true)
          if (screenWidth >= 768) {
            if (scrollTop > this.$refs.banner.offsetHeight - this.$refs.navMenu2.offsetHeight) {
              this.isNavMenu2Fixed = true
              $('#header').slideUp('fast')
            } else {
              this.isNavMenu2Fixed = false
              $('#header').slideDown('fast')
            }
          } else {
            if (scrollTop > this.$refs.banner.offsetHeight) {
              this.isNavMenu2Fixed = true
              $('#header').slideUp('fast')
            } else {
              this.isNavMenu2Fixed = false
              $('#header').slideDown('fast')
            }
          }
        } else {
          this.isNavMenu2Fixed = false
          $('#header').slideDown('fast')
          this.$refs.header.setHeaderFixed(false)
        }
      },
    },
    mounted() {
      window.addEventListener('scroll', this.scrollEvent)
    },
    watch: {
      $route() {
        this.initMenuInfo()
      }
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.scrollEvent)
    },
    computed: {
      ...mapGetters(['lang', 'isMobile', 'solutions']),
      getComponentName() {
        return "Solution"
      }
    }
  }
</script>

<style lang="scss" scoped>
  .solution {
    width: 100%;
    height: auto;
    font-family: Arial, Source Han Sans CN;

    .navMenu2Fixed {
      position: fixed;
      top: 0;
      z-index: 1001;
      box-shadow: 0rem 0rem 0.75rem 0rem rgba(179, 193, 218, 0.41);
    }

    .banner {
      position: relative
    }

    /*二级导航条*/
    .nav-menu2 {
      width: 100%;
      height: 5rem;
      line-height: 5rem;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      background: #FFFFFF;
      // border-bottom: 1px solid rgba(243, 246, 251, 1);
      box-shadow: 0rem 0rem 0.19rem 0rem rgba(179, 193, 218, 0.41);

      .content {
        width: 100%;
        max-width: 75rem;
        display: flex;
        justify-content: space-between;


        .dropdown {
          .dropdown-ul {
            // cursor: pointer;
          }

          .dropicon {
            width: 0.88rem;
            height: 0.56rem;
            margin-top: -0.3rem;
          }

          .dropdown-menu {
            font-size: 1em;
            font-family: Arial, Source Han Sans CN;
            font-weight: 400;
            color: rgba(63, 74, 93, 1);
            line-height: 1.8rem;
            width: 8rem;
            // text-align: center;
            border-top: 0rem;
            border-radius: 4px;

            p {
              cursor: pointer;
              margin: 0.25rem 0;
            }

            .actived, .dropdown-item:hover {
              color: #2D8FFF;
            }

            .dropdown-item:active {
              background: #FFFFFF;
            }

            .disabled {
              color: lightgray;
              cursor: not-allowed
            }

            .disabled:hover {
              color: lightgray;
            }
          }
        }

        .left-title {
          font-size: 1.13rem;
          font-weight: 500;
          color: #333;
        }

        .right-tab-ul {
          #dropdownMenu2 {
            display: flex;
            align-items: center;
          }

          font-size: 1rem;
          font-family: Arial, Source Han Sans CN;
          // font-weight: 500;
          /*letter-spacing: 0.1rem;*/
          // color: #666;
          span {
            margin: 0 0.5rem;
            cursor: pointer;
          }

          .actived {
            color: #3292FF;
          }
        }
      }
    }
  }

  .solution-xs {
    .banner {
      margin-top: 3.5rem;
    }

    .nav-menu2 {
      height: 3.5rem;
      line-height: 3.5rem;

      .content {
        width: 100%;
        max-width: 90%;
        height: 3.5rem;

        .dropdown {
          .dropdown-menu {
            width: 8rem;
            min-width: 140px;
          }
        }

        .left-title {
          font-size: 1rem;
          font-weight: 400;
          white-space: nowrap;
        }

        .right-tab-ul {
          font-size: 14px;

          .dropdown {
            .dropdown-menu {


              p {
                cursor: pointer;
                margin: 0.25rem 0;
                box-sizing: border-box;
                padding: 0 0.8rem;
              }

              .actived, .dropdown-item:hover {
                color: #3292FF;
              }

              .dropdown-item:active {
                background: #FFFFFF;
              }
            }
          }
        }
      }
    }
  }

  .english {
    .nav-menu2 {
      .dropdown-menu {
        text-align: left !important;
        padding: 0 0.8rem !important;
        width: 14rem !important;
        min-width: 240px !important;;
      }
    }

    .nav-menu2-xs {
      &.active {

        #dropdownMenu2 {
          // max-width:90%;
          // margin-left:10%;
          height: 3.5rem;
          // line-height: 1.75rem;
          line-height: normal;

          & > span {
            text-align: right;
            white-space: pre-wrap;
          }
        }
      }

      .left-title {
        .dropdown-menu {
          width: 12rem !important;
        }
      }

      .right-tab-ul {
        .dropdown-menu {
          width: 9rem !important;

          & > p {
            line-height: normal !important;
            margin: 0.8rem 0 !important;
          }
        }
      }
    }
  }

  /deep/ .polygon_icon {
    width: 0.75rem !important;
    height: 0.75rem !important;
    margin: 0 0.7rem 0 0 !important;
  }

  /deep/ .polygon_icon_xs {
    width: 0.6rem !important;
    height: 0.6rem !important;
    margin: -0.1rem 0.5rem 0 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Solution.vue